












import axios from 'axios'
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Links extends Vue {
  links:object = []
  mounted () {
    axios.get('/json/links.json')
      .then(response => {
        this.links = [...response.data]
      })
  }
}

